import React, { useState } from "react";

import { API_TICKETS_CANCELED, getDataFromUrl } from "../../../api";
import ServerPaginatedTable from "../../../Components/Common/ServerPaginatedTable";
import moment from "moment";

const UserDetailTicketCancelList = (props) => {
    const [data, setData] = React.useState([]);
    const [previous, setPrevious] = React.useState("");
    const [next, setNext] = React.useState("");
    const [count, setCount] = React.useState("");

    const onRequestData = (_url) => {
        getDataFromUrl(_url)
            .then((data) => {
                setData(data.results);
                setPrevious(data.previous);
                setNext(data.next);
                setCount(data.count);
                // if (isSearch) calcTotalPageCount(data.count, (data.results).length);
            })
            .catch((e) => {
                console.log(e);
            });
    };

    React.useEffect(() => {
        if (!previous && !next) {
            getDataFromUrl(`${API_TICKETS_CANCELED}/?search=${props.userPhoneNum}`)
                .then((data) => {
                    // console.log(data);
                    setData(data.results);
                    setPrevious(data.previous);
                    setNext(data.next);
                    setCount(data.count);
                })
                .catch((e) => {
                    console.log(e);
                });
        }
    }, []);

    const columns = React.useMemo(
        () => [
            {
                Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" onClick={() => checkedAll()} />,
                Cell: (cellProps) => {
                    return <input type="checkbox" className="customerCheckBox form-check-input" value={cellProps.row.original.id} />;
                },
                id: "#",
            },
            {
                Header: "번호",
                accessor: "row_number",
                id: "",
            },
            // {
            //   Header: 'ID',
            //   accessor: 'id',
            //   id: 'id',
            // },
            /** ["고객", "이름", "상품", "취소일", "취소금액", "row_number"]  */
            {
                Header: "고객번호",
                accessor: "고객",
                id: "order__user__phone_num",
            },
            {
                Header: "성함",
                accessor: "이름",
                id: "order__user__username",
            },
            {
                Header: "티켓상품",
                accessor: "상품",
                id: "ticket_product",
            },
            {
                Header: "취소일",
                accessor: "취소일",
                id: "cancel_date",
                Cell: (cellProps) => {
                    return <span>{moment(cellProps.row.original["취소일"]).format("YYYY-MM-DD HH:mm")}</span>;
                },
            },
            {
                Header: "취소금액",
                accessor: "취소금액",
                id: "canceled_amount",
            },
        ],
        []
    );

    const [modal, setModal] = useState(false);

    const checkedAll = () => {
        const checkall = document.getElementById("checkBoxAll");
        const ele = document.querySelectorAll(".customerCheckBox");

        if (checkall.checked) {
            ele.forEach((ele) => {
                ele.checked = true;
            });
        } else {
            ele.forEach((ele) => {
                ele.checked = false;
            });
        }
    };

    return (
        <div>
            <React.Fragment>
                <ServerPaginatedTable
                    url={API_TICKETS_CANCELED}
                    columns={columns}
                    data={data}
                    previous={previous}
                    next={next}
                    count={count}
                    onRequestData={onRequestData}
                    serachable={false}
                    categories={[
                        // { id: 0, title: "전체", search: "", icon: "ri-store-2-fill" },
                        // { id: 1, title: "예약완료", search: "", icon: "ri-checkbox-circle-line" },
                        // { id: 2, title: "입금대기", search: "", icon: "ri-more-fill" },
                        // { id: 3, title: "최소완료", search: "", icon: "ri-arrow-left-right-fill" },
                    ]}
                />
            </React.Fragment>
        </div>
    );
};

export default UserDetailTicketCancelList;
